import { cloneDoc } from './normalize.js';

const MAX_HISTORY = 50;

/**
 * Create an initial history state.
 * @param {object} doc
 * @returns {{ past: object[], present: object, future: object[] }}
 */
export function createHistory(doc) {
  return { past: [], present: cloneDoc(doc), future: [] };
}

/**
 * Push the current present to the past and set a new present.
 * Clears the future.
 *
 * @param {{ past, present, future }} history
 * @param {object} nextDoc
 * @returns {{ past, present, future }}
 */
export function pushHistory(history, nextDoc) {
  const past = [...history.past, history.present].slice(-MAX_HISTORY);
  return { past, present: cloneDoc(nextDoc), future: [] };
}

/**
 * Undo: move present to future, pop last past entry as new present.
 *
 * @param {{ past, present, future }} history
 * @returns {{ past, present, future }}
 */
export function undo(history) {
  if (history.past.length === 0) return history;
  const past = [...history.past];
  const present = past.pop();
  const future = [history.present, ...history.future];
  return { past, present, future };
}

/**
 * Redo: move present to past, pop first future entry as new present.
 *
 * @param {{ past, present, future }} history
 * @returns {{ past, present, future }}
 */
export function redo(history) {
  if (history.future.length === 0) return history;
  const future = [...history.future];
  const present = future.shift();
  const past = [...history.past, history.present];
  return { past, present, future };
}

export const canUndo = (h) => h.past.length > 0;
export const canRedo = (h) => h.future.length > 0;
